import React from 'react';
import { Link } from 'react-router-dom';
import About from '../components/About';
import Contact from '../components/Contact';
import { Image } from '../lib/icons';

function TikTokIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.74a4.85 4.85 0 0 1-1.01-.05z"/>
    </svg>
  );
}

function YouTubeIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.54 3.5 12 3.5 12 3.5s-7.54 0-9.38.55A3.02 3.02 0 0 0 .5 6.19C0 8.04 0 12 0 12s0 3.96.5 5.81a3.02 3.02 0 0 0 2.12 2.14C4.46 20.5 12 20.5 12 20.5s7.54 0 9.38-.55a3.02 3.02 0 0 0 2.12-2.14C24 15.96 24 12 24 12s0-3.96-.5-5.81zM9.75 15.52V8.48L15.86 12l-6.11 3.52z"/>
    </svg>
  );
}

function AboutPage() {
  return (
    <>
      <About />

      {/* ── Gallery & Social quick links ─────────────────────────────── */}
      <div className="bg-[#0D0D0D] border-t border-gray-800 py-16">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          <Link
            to="/gallery"
            className="group bg-gray-900 border border-gray-800 hover:border-[#00BFFF]/40 rounded-2xl p-8 flex items-start gap-5 transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[#00BFFF]/10 flex items-center justify-center flex-shrink-0">
              <Image className="h-6 w-6 text-[#00BFFF]" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white mb-1 group-hover:text-[#00BFFF] transition-colors">Work Gallery</h2>
              <p className="text-gray-400 text-sm">Custom controllers, board repairs, and mods — see our recent work.</p>
            </div>
          </Link>

          <a
            href="https://www.tiktok.com/@gamefixsolutions"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gray-900 border border-gray-800 hover:border-white/40 rounded-2xl p-8 flex items-start gap-5 transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
              <TikTokIcon className="h-6 w-6 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white mb-1 group-hover:text-white transition-colors">TikTok</h2>
              <p className="text-gray-400 text-sm">Short clips, repair tips, and behind-the-scenes content.</p>
            </div>
          </a>

          <a
            href="https://www.youtube.com/@repaironwheels"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gray-900 border border-gray-800 hover:border-[#FF0000]/40 rounded-2xl p-8 flex items-start gap-5 transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[#FF0000]/10 flex items-center justify-center flex-shrink-0">
              <YouTubeIcon className="h-6 w-6 text-[#FF0000]" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white mb-1 group-hover:text-[#FF0000] transition-colors">YouTube</h2>
              <p className="text-gray-400 text-sm">Full repair videos, builds, and tutorials on the channel.</p>
            </div>
          </a>
        </div>
      </div>

      <Contact />
    </>
  );
}

export default AboutPage;
